import { LitElement } from 'lit';

/**
 *
 * - Increase and decrease number on button click
 */

export default class InputNumber extends LitElement {
  createRenderRoot() {
    return this;
  }

  /** @internal */
  get increaseBtn() {
    return this.querySelector('button:first-child');
  }

  /** @internal */
  get decreaseBtn() {
    return this.querySelector('button:last-child');
  }

  /** @internal */
  get input() {
    return this.querySelector('input');
  }

  connectedCallback() {
    super.connectedCallback();

    this.increaseBtn?.addEventListener('click', this);
    this.decreaseBtn?.addEventListener('click', this);
  }

  handleEvent(e) {
    e.type === 'click' && this.handleClick(e);
  }

  handleClick(e) {
    e.preventDefault();
    e.currentTarget === this.increaseBtn ? this.stepUP() : this.stepDown();
  }

  stepUP() {
    this.input.stepUp();
  }

  stepDown() {
    this.input.stepDown();
  }
}

customElements.get('bu-input-number') ||
  customElements.define('bu-input-number', InputNumber);
